import React from 'react';
import SEOHead from '../../components/seo/SEOHead';
import { motion } from 'framer-motion';

const CopyrightPolicy = () => {
  return (
    <>
      <SEOHead
        title="Copyright policy & DMCA"
        description="Read our copyright policy for the Animatronic Database."
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl font-bold text-content-primary mb-8">Copyright Policy & DMCA</h1>
          
          <div className="prose prose-invert max-w-none space-y-6">
            <p className="text-content-secondary">Effective Date: 01/13/2025</p>

            Big Leaf LLC respects the intellectual property rights of others and expects users to do the same. This Copyright Policy explains how to report copyright infringement.
            
            <section>
              <h2>1. Copyright Ownership</h2>
              <p>All content on Animatronic Database (excluding user-generated or third-party images and videos) is the property of Big Leaf LLC.</p>
            </section>

<section>
  <h2>2. DMCA Takedown Requests</h2>
  <p>
    If you believe your copyright has been infringed, please submit a written request to{' '}
    <a href="mailto:legal@animatronicdatabase.com" className="text-brand hover:text-brand-light">
      legal@animatronicdatabase.com
    </a>{' '}
    including:
  </p>
  <ul>
    <li>Your contact information (name, email address).</li>
    <li>A description of the copyrighted work.</li>
    <li>The URL of the infringing content.</li>
    <li>A statement of good faith belief that the use is unauthorized.</li>
    <li>A statement that your complaint is accurate and you are the copyright owner or authorized to act on their behalf.</li>
    <li>Your physical or electronic signature.</li>
  </ul>
</section>

<section>
  <h2>3. Counter-Notice</h2>
  <p>
    If you believe your content was removed in error, you may submit a counter-notice to{' '}
    <a href="mailto:legal@animatronicdatabase.com" className="text-brand hover:text-brand-light">
      legal@animatronicdatabase.com
    </a>{' '}
    including:
  </p>
  <ul>
    <li>Your contact information.</li>
    <li>Identification of the removed content and its location.</li>
    <li>A statement of good faith belief that the content was removed in error.</li>
    <li>Consent to jurisdiction in Georgia, USA.</li>
    <li>Your physical or electronic signature.</li>
  </ul>
</section>


            <section>
              <h2>4. Contact</h2>
              <p>
                For questions about these terms, please contact{' '}
                <a href="mailto:legal@animatronicdatabase.com" className="text-brand hover:text-brand-light">
                  legal@animatronicdatabase.com
                </a>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default CopyrightPolicy;